import { COUPLE } from "@/lib/constants";
import { Heart } from "lucide-react";
import { useReveal } from "@/contexts/RevealContext";

export default function Footer() {
  const { revealed } = useReveal();
  return (
    <footer
      data-testid="footer"
      className="relative z-10 mt-24 border-t border-gold/15 bg-ink-900/70 backdrop-blur-md"
    >
      <div className="max-w-6xl mx-auto px-6 py-14 text-center">
        <div className="ornament-divider mb-8">
          <Heart size={14} className="text-gold/80" />
        </div>
        <p className="font-serif text-2xl md:text-3xl text-ivory leading-relaxed">
          With love, <span className="italic gold-text">{COUPLE.groom} &amp; {COUPLE.bride}</span>{" "}
          <Heart size={18} className="inline -mt-1 text-burgundy-glow fill-burgundy-glow" />
        </p>
        <p
          data-testid="footer-hashtag"
          className="mt-4 font-serif italic text-3xl md:text-4xl hashtag-glow"
        >
          #PandA
        </p>
        <p className="mt-6 text-[0.7rem] uppercase tracking-[0.4em] text-ivory-dim">
          {revealed ? (
            <span data-testid="footer-date">{COUPLE.weddingDateLabel} · {COUPLE.venue}</span>
          ) : (
            <span className="italic tracking-widest text-gold/70">#PandA · A surprise awaits</span>
          )}
        </p>
        <p className="mt-2 text-xs text-ivory-dim/70">
          A love story, written together. ✨
        </p>
      </div>
    </footer>
  );
}
